import qs from 'qs'

// urlQueryString: a url query string e.g. ?q=something
// returns an object e.g. { q: 'something' }
export const parseQueryString = (urlQueryString) => {
  return qs.parse(urlQueryString, { ignoreQueryPrefix: true })
}

// query: object with key and value e.g. { q: 'something' }
// returns a query string e.g. ?q=something
const generateQueryString = (query) => {
  const cleanedQuery = Object.entries(query).reduce((acc, [key, value]) => {
    if (
      value === undefined ||
      value === null ||
      value === '' ||
      (Array.isArray(value) && !value.length)
    ) {
      return acc
    }
    return { ...acc, [key]: value }
  }, {})

  return qs.stringify(cleanedQuery, {
    addQueryPrefix: true,
    arrayFormat: 'repeat',
  })
}

// history: React BrowserHistory object
// pathName: existing pathName, usually location.pathname, e.g. /some/path
// queryString: a url query string e.g. ?q=something
// TODO: decouple from React BrowserHistory object
export const updateBrowserHistory = (history, pathName, queryString) => {
  history.push({
    pathname: pathName,
    search: queryString,
  })
}

// history: React BrowserHistory object
// pathName: existing pathName, usually location.pathname, e.g. /some/path
// query: object with key and value e.g. { q: 'something' }
export const setURLQuery = (history, pathName, query) => {
  const queryString = generateQueryString(query)
  updateBrowserHistory(history, pathName, queryString)
}
